module.exports = __webpack_public_path__ + "static/scenario3-thumb-1a531c4cf410eec4296ff9289a53ae8b.png";